import React from "react";
import {FutureDayBar} from "./day_bars/FutureDayBar";
import {ConversionDayBar} from "./day_bars/ConversionDayBar";
import {DashboardBarsCell} from "./DashboardBarsCell";
import {COLUMN_CELL_INVALID_CONTENT} from "../../../columns";

export class DashboardFullPeriodConversionsCell extends DashboardBarsCell {
    renderDayBar(dayNumber, alertLevel, alertData, isToday, alert_snoozed, rowType) {
        return <ConversionDayBar key={dayNumber}
                                 dayNumber={dayNumber + 1}
                                 dayValue={alertData.formatted_value_of_day}
                                 value={alertData.formatted_value}
                                 expectedValue={alertData.expected_value}
                                 conversionsSource={this.props.data.conversions_source}
                                 proportion={alertData.proportion}
                                 alertLevel={alertData.level}
                                 isToday={isToday}
                                 fluctuationPercentage={alertData.fluctuation_percentage}
                                 level={alertLevel}
                                 rowType={rowType}
                                 fluctuation={alertData.fluctuation}
                                 isSnoozed={alert_snoozed}
                                 valueByType={alertData.conversions_by_action_name_until_datetime}
                                 dayValueByType={alertData.conversions_by_action_name_for_date}
                                 conversionsByAccount={alertData.conversions_by_account_until_datetime}

        />
    }

    getAlertLevel(rowType, alertData) {
        return alertData.level;
    }

    addFutureDaysBars(pastAndTodayBars) {
        for (let i = 0; i < this.props.data.remaining_days_of_current_period; i++) {
            pastAndTodayBars.push(<FutureDayBar key={pastAndTodayBars.length + i}/>)
        }

        return pastAndTodayBars;
    }

    render() {
        return (
            <td className={`graphic-data  ${this.processingCssClasses()}`}>
                <div className="graphic-conversions">
                    <div style={{paddingTop: "6px"}}>{this.renderWarningIfNecessary()}</div>
                    {this.cellContent()}
                </div>
            </td>
        )
    }

    hasExpectedConversionsInfo() {
        if(this.props.data === null )
            return false;

        const someDayInformation = this.props.data.alerts_by_day[0];
        return someDayInformation.expected_value !== COLUMN_CELL_INVALID_CONTENT && someDayInformation.expected_value !== null
    }

    hasConversionsInfo() {
        // `alerts_by_day` puede no venir en absoluto: el backend arma la columna sin esa clave
        // cuando la fila no tiene datos del indicador (`IndicatorColumn.data()`). Comparar sólo
        // contra `null` dejaba pasar ese caso y la celda reventaba al recorrer los días.
        return this.props.data !== null && this.props.data !== undefined &&
            this.props.data.alerts_by_day !== null && this.props.data.alerts_by_day !== undefined
    }

    cellContent() {
        if (this.hasConversionsInfo()) {
            const pastAndTodayBars = this.barsForPastDaysAndToday();
            return this.addFutureDaysBars(pastAndTodayBars);
        } else {
            return <span>{COLUMN_CELL_INVALID_CONTENT}</span>
        }
    }
}
